import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { IoLocation } from "react-icons/io5";
import { useStores } from "../../store/index";
import { useObserver } from "mobx-react";

const Contact = () => {

    const { ResumeStore } = useStores();

    return useObserver(() => (
        <div className="flex flex-col  items-start px-1 md:pl-11 lg:pl-24 gap-2 text-sm lg:text-xl md:mt-8 lg:mt-10">
            <div className="flex gap-5 md:gap-7 mt-3  items-center ">
                {ResumeStore.resumeBuilder.personalDetails?.phone != "" && <div className=" bg-resume_primary rounded-full md:w-6 md:h-6 w-6 h-6 p-2 flex items-center justify-center">
                    <FaPhoneAlt className=" text-sm " />
                </div>}

                <p className="text-white ml-[-15px]" >{ResumeStore.resumeBuilder.personalDetails?.phone ?? "+123-456-789"}</p>
            </div>
            <div className="flex gap-5 md:gap-7 mt-3 items-center">
                {ResumeStore.resumeBuilder.personalDetails?.email != "" && <div className="bg-resume_primary rounded-full md:w-6 md:h-6 w-6 h-6 p-2 flex items-center justify-center">
                    <MdEmail className="text-sm" />
                </div>}

                <p className="text-white break-words  ml-[-15px] " >{ResumeStore.resumeBuilder.personalDetails?.email ?? "hello@reallygreatsite.com"}</p>
            </div>
            <div className="flex gap-5 md:gap-7 mt-3 items-center">
                {(ResumeStore.resumeBuilder.personalDetails?.country || ResumeStore.resumeBuilder.personalDetails?.city || ResumeStore.resumeBuilder.personalDetails?.address) && (<div className="bg-resume_primary rounded-full md:w-6 md:h-6 p-2 w-6 h-6 flex items-center justify-center">
                    <IoLocation className="text-sm" />
                </div>)}
                <p className="text-white break-words ml-[-15px]" >{`${ResumeStore.resumeBuilder.personalDetails?.address} ${ResumeStore.resumeBuilder.personalDetails?.city} ${ResumeStore.resumeBuilder.personalDetails?.country}`}</p>
            </div>

        </div>
    ));
}

export default Contact;